import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  DEFAULT_BADGES,
  KPI_HEALTH_BADGES,
  PORTFOLIO_MILESTONE_BADGES,
  STUDY_MILESTONE_BADGES
} from '@catalogues';
import { BadgeConfig, BadgeTypes } from '@models';

@Component({
  selector: 'status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss']
})
export class StatusBadgeComponent implements OnInit, OnChanges {
  @Input() type!: BadgeTypes;
  @Input() badgeKey!: string;
  @Input() showLabel = true;

  kpiHealthBadges = KPI_HEALTH_BADGES;
  portfolioMilestoneBadges = PORTFOLIO_MILESTONE_BADGES;
  studyMilestonesBadges = STUDY_MILESTONE_BADGES;
  defaultBadges = DEFAULT_BADGES;
  badge: BadgeConfig | undefined = undefined;

  ngOnInit() {
    this.getBadgeConfig();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['badgeKey'] || changes['type']) {
      this.getBadgeConfig();
    }
  }

  getBadgeConfig() {
    switch (this.type) {
      case 'kpiHealth':
        this.badge =
          this.kpiHealthBadges[this.badgeKey as keyof typeof this.kpiHealthBadges] ||
          this.defaultBadges['No Data'];
        break;
      case 'portfolioMilestone':
        this.badge =
          this.portfolioMilestoneBadges[
            this.badgeKey as keyof typeof this.portfolioMilestoneBadges
          ];
        break;
      case 'studyMilestoneStatus':
        this.badge =
          this.studyMilestonesBadges[this.badgeKey as keyof typeof this.studyMilestonesBadges];
        break;
    }
    return this.badge;
  }
}
